import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=a0490fae&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=a0490fae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0490fae",
  null
  
)

export default component.exports